/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Target_LanguageInputs */



/**
* | output |
* | --- |
* | "Target Language" |
*
* @param {Target_LanguageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const target_language = /** @type {((inputs?: Target_LanguageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Target_LanguageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langue cible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zielsprache")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lingua di destinazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Целевой язык")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lengua de llegada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("目标语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ターゲット言語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य भाषा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Língua de destino")
	return /** @type {LocalizedString} */ ("Target Language")
});